export default "__VITE_ASSET__nTyuw1oE__"